import _ from "lodash";
import { ReactNode } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import NavDrawer from "src/apps/PostFundedDashboard/components/NavDrawer";
import { NavItems } from "src/apps/PreFundedDashboard/components/NavItems";
import { EditProfileScreen } from "src/apps/shared/EditProfile";
import {
  DashboardShell,
  // FooterDisclosure
} from "src/components";

import { Link } from "react-router-dom";
import { AccountDropdown } from "src/components/AccountDropdown";
import { Logo } from "src/components/Logo";
import { AppDetailsRoutes } from "./screens/AppDetails";

// const PreFundedDashboardLayout = ({ footer }: { footer?: ReactNode }) => (
//   <>
//     <DashboardShell footer={footer} header={<Header />} sidebar={<PreFundedSidebar />}>
//       <Outlet />
//     </DashboardShell>
//     <NavDrawer NavItems={NavItems} />
//   </>
// );

// const Footer = () => (
//   <div className="pb-4 px-8 w-[95%] mt-auto translate-y-[100px]">
//     <FooterDisclosure />
//   </div>
// );

const PreFundedDashboardHeader = () => {
  return (
    <div className="flex items-center p-2 md:pl-6 md:pt-4 md:pb-4 md:pr-6 border-b-2 border-solid">
      <Link className="hidden md:block" to="/">
        <Logo />
      </Link>
      <div className="md:pt-1 md:ml-6 overflow-x-scroll flex flex-row">
        <NavItems />
      </div>
      <div className="flex ml-auto">
        <AccountDropdown />
      </div>
    </div>
  );
};

const PreFundedDashboardLayout = ({ footer }: { footer?: ReactNode }) => {
  return (
    <>
      <DashboardShell footer={footer} header={<PreFundedDashboardHeader />}>
        <Outlet />
      </DashboardShell>
      <NavDrawer NavItems={NavItems} />
    </>
  );
};

export const PreFundedDashboard = () => {
  return (
    <Routes>
      {/* <Route element={<PreFundedDashboardLayout footer={<Footer />} />}> */}
      <Route path="/" element={<PreFundedDashboardLayout />}>
        <Route path="/" element={<AppDetailsRoutes />} />
        <Route path="*" element={<AppDetailsRoutes />} />
        <Route path="profile" element={<EditProfileScreen />} />;
      </Route>
    </Routes>
  );
};
